import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  updateMediaContentPriority,
  getMediaContents,
} from "../../../../action/masters/mediaContentActionCreator";
import {
  changePositionOnDrag,
  prioratiseItems,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateMediaContentPriority,
  IMediaContentData,
} from "../../../../models/master/mediaContent";
import { setMediaContents } from "../../../../store/slices/master/mediaContentSlice";
import LoaderSpinner from "../../../../common-components/loader";

const PriorityMediaContent = (props: IUpdateMediaContentPriority) => {
  const {
    updateMediaContentPriority,
    getMediaContents,
    mediaContents,
    configUserRole,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const dispatch = useDispatch();
  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateMediaContentPriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    /////method 1
    setLoader(true);
    
    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);
    
    setfilteredItems([..._items]);
    updateMediaContentPriority(_items, setAlert);
    //let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
    // await setfilteredItems(_items);
    // //const itemsForSave = _items.slice(newPos);
    // updateAppPriority(_items, setAlert);

    /////method 2
    // let _filteredItems = [...filteredItems]
    // let item = _filteredItems[index];
    // item.displayOrNot = __displayOrNot;
    // _filteredItems[index] = item;
    // updateAppPriority(item, setAlert);
    // setFilteredItems(_filteredItems);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllMediaContents = async (configUserRole: number) => {
    setLoader(true)
    try {
      await getMediaContents(configUserRole);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllMediaContents(configUserRole);
    return () => {
      dispatch(setMediaContents([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    mediaContents && setfilteredItems(cloneDeep(mediaContents));
  }, [mediaContents]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Media Contents</h2>
        </div>
  
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner />
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: IMediaContentData) => item.displayOrNot)
                  .map((mediaContent: IMediaContentData, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{mediaContent.priority}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={mediaContent.displayOrNot}
                            id={mediaContent.priority + "mediaContent"}
                            onChange={() => {
                              
                              ChangeVisibleOrNot(
                                mediaContent.id ?? 0,
                                !mediaContent.displayOrNot
                              );
                            }}
                          />
                          <label
                            htmlFor={mediaContent.priority + "mediaContent"}
                          ></label>
                        </div>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img
                            src={
                              mediaContent.image
                                ? baseURL + mediaContent.image
                                : ""
                            }
                            alt=""
                          />
                        </div>
                        <h2>{mediaContent.title}</h2>
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: IMediaContentData) => !item.displayOrNot)
                .map((mediaContent: IMediaContentData, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{}</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={mediaContent.displayOrNot}
                          id={mediaContent.priority + ""}
                          onChange={() => {
                            
                            ChangeVisibleOrNot(
                              mediaContent.id ?? 0,
                              !mediaContent.displayOrNot
                            );
                          }}
                        />
                        <label htmlFor={mediaContent.priority + ""}></label>
                      </div>
                    </div>
                    <div className="btm">
                      <div className="img">
                        <img
                          src={
                            mediaContent.image ? baseURL + mediaContent.image : ""
                          }
                          alt=""
                        />
                      </div>
                      <h2>{mediaContent.title}</h2>
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  updateMediaContentPriority: (data: any, callBack: Function) =>
    updateMediaContentPriority(data, callBack),
  getMediaContents: (configUserRole: number) =>
    getMediaContents(configUserRole),
};

function mapStateToProps(state: any) {
  return {
    mediaContents: state.mediaContent.mediaContents,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriorityMediaContent);
